import { Avatar, Center, Container, Divider, Group, Loader, Stack, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../auth/SessionContext";
import LoginButton from "../LoginButton/LoginButton";
import { SubscriptionPanel } from "../Subscription/SubscriptionPanel";
import { BUNDLE_ENABLED } from "../../config/features";
import { OrderList } from "../OrderList/OrderList";

export default function ProfileContent(): React.JSX.Element {
  const { sessionData, loadSessionDataAsync } = useSession();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadSessionDataAsync().then(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "60vh" }}>
        <Loader color="gray" size="xl" />
      </Center>
    );
  }

  if (!sessionData.logged_in) {
    return (
      <Center style={{ minHeight: "60vh" }}>
        <Stack align="center" gap="lg" style={{ maxWidth: 400, textAlign: "center", padding: "2rem" }}>
          <Title order={2} style={{ color: "#fff" }}>Sign in to your account</Title>
          <Text c="dimmed" size="sm">
            Log in with Steam to manage your SimRacing Solutions subscription,
            view your license keys, and check your billing history.
          </Text>
          <LoginButton />
        </Stack>
      </Center>
    );
  }

  return (
    <Container size="lg" py="xl">
      {/* User header */}
      <Group mb="xl" gap="md">
        <Avatar src={sessionData.avatar} size={56} radius="xl" />
        <div>
          <Title order={3} style={{ color: "#fff" }}>{sessionData.name}</Title>
          <Text size="sm" c="dimmed">Steam ID: {sessionData.steam_id}</Text>
        </div>
      </Group>

      <Divider mb="xl" />

      {/* Subscription management */}
      <Title order={4} mb="md" style={{ color: "#fff" }}>My Subscription</Title>
      {BUNDLE_ENABLED && <SubscriptionPanel />}

      <Divider my="xl" />

      {/* One-time purchase keys */}
      <Title order={4} mb="md" style={{ color: "#fff" }}>My One-Time Purchases</Title>
      <OrderList />
    </Container>
  );
}
